import { getEnv } from '@xbcb/ui-utils';

export const isAdCvdEnabled = (): boolean => {
  const { stage } = getEnv();
  return true;
};
